/**
 * Creator public API helpers — Experience Engine Destination 3.
 */

import api from "../../Environment";

export function creatorPublicPath(slug) {
  const cleaned = String(slug || "").trim();
  if (!cleaned) {
    return "/creators";
  }
  return `/creator/${cleaned}`;
}

export async function fetchCreatorBySlug(slug) {
  const cleaned = String(slug || "").trim();
  if (!cleaned) {
    return null;
  }

  try {
    const response = await api.postMethod("creator/show", {
      slug: cleaned,
    });
    const body = response && response.data ? response.data : response;
    if (body && body.success && body.data) {
      return body.data;
    }
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * Public creator directory (approved + public visibility).
 * @param {{ featured?: boolean, q?: string, page?: number, per_page?: number }} [opts]
 * @returns {Promise<{ creators: array, pagination: object|null, error: boolean }>}
 */
export async function fetchCreatorDirectory(opts = {}) {
  const input = {};
  if (opts.featured === true) {
    input.featured = 1;
  } else if (opts.featured === false) {
    input.featured = 0;
  }
  if (opts.q) {
    input.q = String(opts.q).trim();
  }
  if (opts.page) {
    input.page = opts.page;
  }
  if (opts.per_page) {
    input.per_page = opts.per_page;
  }

  try {
    const response = await api.postMethod("creator/list", input);
    const body = response && response.data ? response.data : response;
    if (body && body.success && body.data) {
      const creators = Array.isArray(body.data.creators)
        ? body.data.creators
        : [];
      return {
        creators,
        pagination: body.data.pagination || null,
        error: false,
      };
    }
    return { creators: [], pagination: null, error: true };
  } catch (e) {
    return { creators: [], pagination: null, error: true };
  }
}
